import API from 'src/services/api';

import { IJobsMetrics } from './types';
import { AxiosResponse } from 'axios';

const metricsApi = {
  async fetchJobsMetrics(): Promise<AxiosResponse<IJobsMetrics>> {
    return await API.get(`/metrics/jobs`);
  },
};

export default metricsApi;
